import React, { Fragment, useEffect } from 'react';
import { useGlobal } from 'reactn';
import { BotIframe } from './BotIframe';
import {
    Logo, BotTopHolder, BotTop, BotTexts, BotTextBlue, BotTextRed, BotImage,
    BotMobile, BotMobileImage,
} from './index.style';

export const BotGeneric = ({ name, code, source, sourceName, lead, image, content_0, content_1 }) => {
    const [, setFullscreen] = useGlobal('fullscreen');
    useEffect(() => {
        setFullscreen(true);

        return () => {
            setFullscreen(false);
        }
    }, [setFullscreen]);

    return (<Fragment>
        <BotTopHolder>
            <BotTop>
                <Logo />
                <BotTexts>
                    <BotTextBlue>{content_0}</BotTextBlue>
                    <BotTextRed>{content_1}</BotTextRed>
                </BotTexts>
                <BotImage src={image} alt={content_1} />
                <BotMobileImage src={image} alt={content_1} />
            </BotTop>
        </BotTopHolder>
        <BotMobile>
            <BotTextBlue>{content_0}</BotTextBlue>
            <BotTextRed>{content_1}</BotTextRed>
        </BotMobile>

        <BotIframe code={code} source={source} lead={lead} sourceName={sourceName} />
    </Fragment>);
};
